import React, { useMemo } from 'react';

import { SearchkitWrapper as RSKSearchkitWrapper } from '@uncinc/react-searchkit';
import type { SearchkitWrapperProps } from '@uncinc/react-searchkit/dist/components/Wrapper';

import SearchErrorBoundary from '../ErrorBoundary';
import { withSearchErrorHandling } from './requestOptions';

/**
 * The SearchkitWrapper from @uncinc/react-searchkit, with search error
 * handling: failed requests put InstantSearch in its `error` status (see
 * `requestOptions.ts`), and render errors are caught by an error boundary.
 * Use this instead of the library's SearchkitWrapper.
 */
const SearchkitWrapper = React.forwardRef<HTMLDivElement, SearchkitWrapperProps>((props, ref) => {
  const {
    requestOptions,
    ...restProps
  } = props;

  const requestOptionsWithErrorHandling = useMemo(
    () => withSearchErrorHandling(requestOptions),
    [requestOptions],
  );

  return (
    <SearchErrorBoundary>
      <RSKSearchkitWrapper
        {...restProps}
        ref={ref}
        requestOptions={requestOptionsWithErrorHandling}
      />
    </SearchErrorBoundary>
  );
});

export default SearchkitWrapper;
